import LogDetailsModalsContainer from '../components/AuditLogComps/LogDetailsModalsContainer';
import ShowAllAuditLogs from '../components/AuditLogComps/ShowAllAuditLogs';
import PageTitle from '../components/CommonComps/Titles/PageTitle';
import AuditLogProvider from '../contexts/AuditLogProvider';

const AuditLogs = () => {
  // rendering audit logs page component here
  return (
    <>
      <PageTitle title='Audit Logs' />

      <AuditLogProvider>
        <ShowAllAuditLogs />
        <LogDetailsModalsContainer />
      </AuditLogProvider>
    </>
  );
};

export default AuditLogs;
